// extracted by mini-css-extract-plugin
export default {"gameLayout":"App_gameLayout__R-MWz","soundsContainer":"App_soundsContainer__GWAeP"};